module.exports = __webpack_public_path__ + "img/onboarding_add_delivery_request.52299710.png";